import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$enableServerSideMenuProcessing',
  initialState,
  reducers: {
    setEnableServerSideMenuProcessing(
      state,
      action: PayloadAction<boolean | undefined>,
    ) {
      return Boolean(action.payload);
    },
  },
});

export const { setEnableServerSideMenuProcessing } = slice.actions;
export default slice.reducer;
